import { render, staticRenderFns } from "./LeftBox1.vue?vue&type=template&id=3dcb71b9&scoped=true"
import script from "./LeftBox1.vue?vue&type=script&lang=js"
export * from "./LeftBox1.vue?vue&type=script&lang=js"
import style0 from "./LeftBox1.vue?vue&type=style&index=0&id=3dcb71b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb71b9",
  null
  
)

export default component.exports